<template>
  <div class="about_address mt_7 pt_6">
    <title-box text="联系我们"></title-box>
    <div class="address content_box d_flex">
      <div class="qr_box d_flex justify_content_center w_100">
        <div class="qr_item d_flex flex_column align_items_center">
          <img src="@/assets/about-us/qrcode.png" alt="二维码" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBox from "@/components/title.vue";
export default {
  name: "Address",
  components: {
    TitleBox
  },
  data() {
    return {
      data: []
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.about_address {
  background: #faf9f7;
  padding: 70px;
  .address {
    margin-top: 55px;
  }
  .qr_box {
    gap: 0;
  }
  .qr_item {
    img {
      width: 200px;
      height: 200px;
      margin-bottom: 18px;
    }
  }
}
</style>
